import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchCommentsCreator } from 'creators/comments';

import { selectVideoDuration } from 'selectors/videoPlayer';

const CommentFetch = props => {
  const comments = useSelector(state => state.comments);
  const dispatch = useDispatch();
  const videoLength = useSelector(selectVideoDuration);

  useEffect(() => {
    if (!comments.has_fetched && !comments.is_fetching) {
      dispatch(fetchCommentsCreator());
    }
  }, [
    comments.comments,
    comments.has_fetched,
    comments.is_fetching,
    dispatch,
    videoLength,
  ]);

  return comments.has_fetched && props.children ? props.children : null;
};

export default CommentFetch;
